import { useCallback } from "react";

import toast from "react-hot-toast";

import { CalendarIcon } from "lucide-react";

import { Button } from "simplydo/react/ui/button";
import type { ButtonProps } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";

import api from "api";
import util from "utils/utils";

type GetCalendarLinkButtonProps = { calendarId: string } & Omit<
  ButtonProps,
  "onClick" | "children"
>;

const GetCalendarLinkButton = ({
  calendarId,
  ...buttonProps
}: GetCalendarLinkButtonProps) => {
  const getCalendarSyncUrl = useCallback(() => {
    api.calendars.getCalendarSyncUrl(
      calendarId,
      ({ syncUrl }) => {
        void util.copyToClipboard(syncUrl);
      },
      (error) => {
        toast.error(error.message);
      },
    );
  }, [calendarId]);

  return (
    <Button
      title="Subscribe in Google Calendar, Apple Calendar, Outlook, or other apps"
      {...buttonProps}
      onClick={getCalendarSyncUrl}
    >
      <Icon icon={CalendarIcon} />
      Get calendar link
    </Button>
  );
};

export default GetCalendarLinkButton;
